import React from "react";
import { AlertTriangle, CheckCircle2, ArrowRight } from "lucide-react";
import { IMPORTER_CHALLENGES, BABUL_SOLUTIONS } from "../data/site";

export default function ImportersProblem() {
  return (
    <section id="importers" data-testid="importers-problem-section" className="py-20 lg:py-32 bg-navy relative overflow-hidden">
      <div className="absolute inset-0 grid-overlay opacity-10" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-3xl mb-16">
          <div className="overline mb-4" style={{ color: "var(--gold)" }}>
            Why Importers Choose Us
          </div>
          <h2 className="section-heading text-white text-3xl md:text-4xl lg:text-5xl font-bold">
            Buyers don't struggle to <span className="italic text-gold">sell</span> Indian products.
            <br className="hidden md:block" />
            They struggle to <span className="italic text-gold">source</span> them reliably.
          </h2>
          <p className="mt-6 text-lg text-white/70 max-w-2xl">
            Overseas demand for authentic Indian FMCG is strong — the real challenge is
            finding a supplier who can deliver consistently, month after month.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6 lg:gap-10">
          {/* Problems */}
          <div className="rounded-3xl p-8 lg:p-10 bg-white/[0.04] border border-white/10 backdrop-blur-sm">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-11 h-11 rounded-xl bg-red-500/15 text-red-300 flex items-center justify-center">
                <AlertTriangle className="w-5 h-5" />
              </div>
              <div className="font-display text-2xl text-white font-bold">Common Problems</div>
            </div>
            <ul className="space-y-3">
              {IMPORTER_CHALLENGES.map((c, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 p-4 rounded-xl bg-white/[0.03] border border-white/5"
                >
                  <span className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2 shrink-0" />
                  <span className="text-white/85">{c.text}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Solutions */}
          <div className="rounded-3xl p-8 lg:p-10 bg-emerald text-white shadow-2xl">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-11 h-11 rounded-xl bg-white/15 flex items-center justify-center">
                <CheckCircle2 className="w-5 h-5" />
              </div>
              <div className="font-display text-2xl font-bold">The Babul Solution</div>
            </div>
            <ul className="space-y-3">
              {BABUL_SOLUTIONS.map((s, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 p-4 rounded-xl bg-white/10 border border-white/15"
                >
                  <CheckCircle2 className="w-5 h-5 shrink-0 mt-0.5" />
                  <span>{s}</span>
                </li>
              ))}
            </ul>
            <a
              href="#contact"
              data-testid="importers-cta"
              className="mt-7 inline-flex items-center gap-2 bg-white text-emerald font-semibold px-6 py-3.5 rounded-full hover:bg-white/90 transition-all"
            >
              Start Sourcing With Us <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
